import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=5073f752"
import script from "./ContactPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5073f752')) {
      api.createRecord('5073f752', component.options)
    } else {
      api.reload('5073f752', component.options)
    }
    module.hot.accept("./ContactPage.vue?vue&type=template&id=5073f752", function () {
      api.rerender('5073f752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/contact/ContactPage.vue"
export default component.exports